<!-- =========================================================================================
  File Name: UserList.vue
  Description: User List page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="page-user-list">
    <div class="vx-card p-6">
      <div class="flex flex-wrap items-center">
        <!-- ITEMS PER PAGE -->
        <div class="flex-grow">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
              <span class="mr-2">{{ currentPage * paginationPageSize - (paginationPageSize - 1) }} - {{ projectMembers.length - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : projectMembers.length }} of {{ projectMembers.length }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
            <vs-dropdown-menu>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(10)">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(25)">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(30)">
                <span>30</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>
        <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
        <!-- <datepicker class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4" placeholder="날짜" :language="$vs.rtl ? langHe : langEn" v-model="selectDate" :highlighted="highlightedFn"/> -->
        <vs-input class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4" v-model="searchQuery" @input="updateSearchQuery" placeholder="Search..." />

        <!-- <div v-if="activeUserLevel >= 3" class="p-3 rounded-lg d-theme-dark-light-bg cursor-pointer flex items-end justify-center text-lg font-medium w-35">
          <vue-excel-xlsx :data="excelData" :columns="excelColumns" :filename="excelFileName" :sheetname="'sheet'">
            <vs-button  icon-pack="feather" icon="icon-download" type="flat" style="margin-left:8px; margin-right:8px; margin-bottom:5px;" color="dark" size="small">Export</vs-button>
          </vue-excel-xlsx>
        </div> -->
      </div>
      <!-- AgGrid Table -->
      <ag-grid-vue
        ref="agGridTable"
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="projectMembers"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl">
      </ag-grid-vue>
      <vs-pagination
        :total="totalPages"
        :max="7"
        v-model="currentPage"/>
    </div>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue"
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import vSelect from 'vue-select'
import Datepicker from 'vuejs-datepicker';
import { ko, he } from "vuejs-datepicker/src/locale"
// import Vue from 'vue'
// Store Module
// import moduleInsight from '@/store/insight/moduleInsight.js'

// Cell Renderer
import ProjectLink from "./cell-renderer/ProjectLink.vue"
// import InsightStatus from "./cell-renderer/InsightStatus.vue"
// import InsightTotalAttend from "./cell-renderer/InsightTotalAttend.vue"
// import InsightActions from "./cell-renderer/InsightActions.vue"


export default {
  components: {
    AgGridVue,
    vSelect,
    // InsightLink,
    // InsightStatus,
    // InsightTotalAttend,
    // InsightActions,
    ProjectLink,
    Datepicker
  },
  data() {
    return {
      excelFileName:'',
      excelColumns:[],
      excelData:[],
      days:[],
      highlightedFn: {},
      langHe: he,
      langEn: ko,
      searchQuery: "",
      // AgGrid
      gridApi: null,
      gridOptions: {},
      defaultColDef: {
        sortable: true,
        resizable: true,
      },
      columnDefs: [
        {
          headerName: '이름',
          field: 'name',
          width: 101,
          cellRendererFramework: 'ProjectLink'
        },
        {
          headerName: '전체업무',
          field: 'task_count',
          width: 101,
        },
        {
          headerName: '블로그',
          field: 'blog_count',
          width: 101,
        },
      ],
      // Cell Renderer Components
      components: {
        ProjectLink
      },
      memeberData: [],
    }
  },

  computed: {
    currentPage: {
      get() {
        if(this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
        else return 1
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1)
      }
    },
    projectMembers() {
      return this.$store.state.task.projectMembers
    },
    paginationPageSize() {
      if(this.gridApi) return this.gridApi.paginationGetPageSize()
      else return 10
    },
    totalPages() {
      if(this.gridApi) return this.gridApi.paginationGetTotalPages()
      else return 0
    },
    doneTasks(){
      return this.$store.state.task.doneTasks
    },
  },
  methods: {
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val)
    },
  },
  mounted() {
    this.gridApi = this.gridOptions.api
  },
  created() {
    // for(var j in this.projectMembers){
    //   this.memeberData.push({name:this.projectMembers[j].name, user_id:this.projectMembers[j].user_id})
    // }
    // for(var i in this.doneTasks){
    //   var index = this.memeberData.findindex((member)=>member.user_id == this.doneTasks[i].user_id)
    //   Vue.set(this.memeberData[index], 'startDate', state.events[index].start_time)
    //   // this.memeberData[index]
    // }
    // console.log(this.projectMembers)
  }
}

</script>

<style lang="scss">
#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
</style>
